"use strict";

Shopify.theme.jsProduct = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsProduct = $.extend(this, Shopify.theme.getSectionData($section)); //Ensure product media libraries are present

    // Executer klaviyo BIS code if settings are enabled.
    if (Shopify.theme_settings.enable_klaviyo_bis && Shopify.theme_settings.klaviyo_company_id != '') {
      Shopify.theme.jsProduct.enableKlaviyoBIS();
    }

    window.Shopify.loadFeatures([{
      name: 'model-viewer',
      version: '0.8'
    }, {
      name: 'shopify-xr',
      version: '1.0'
    }, {
      name: 'model-viewer-ui',
      version: '1.0'
    }], Shopify.theme.productMedia.setupMedia);

    var $productGallery = $section.find('.product-gallery__main');
    var $stickyElement = $section.find('.sticky-product-scroll');

    if ($productGallery) {
      Shopify.theme.jsProduct.enableSlideshow($productGallery);

      if (Shopify.theme.jsProduct.enable_zoom) {
        Shopify.theme.jsProduct.enableZoom($productGallery);
      }

      if (Shopify.theme.jsProduct.enable_product_lightbox) {
        Shopify.theme.jsProduct.enableLightbox($productGallery);
      }
    }

    if ($stickyElement && isScreenSizeLarge() && Shopify.theme.jsProduct.template == 'image-scroll') {
      Shopify.theme.jsProduct.enableStickyScroll($stickyElement);
    }


    // pdp guide handler
    var $productFeaturesSection = $('.product-features-section');
    if ($productFeaturesSection) {
      Shopify.theme.jsProduct.featuresEventHandler();
    }

    // pdp size guide handler
    var $productSizeGuide = $('.product__size-guide');
    if ($productSizeGuide) {
      Shopify.theme.jsProduct.sizeGuideHandler($productSizeGuide,$productSizeGuide.find('.product__size-guide-title'));
    }

    // pdp size guide and fit guide handler on description section
    var $productDesLinks = $('.product__main-description-links');
    if($productDesLinks) {
      $productDesLinks.find('.product__main-description-fit')
      .on('click',()=>{
        $productSizeGuide.find('.product__size-guide-title').click();
        const $fitGuideTitle = $('.product__size-guide-popup').find('.popup-subtitle-fit span');
        $fitGuideTitle.click();
      });

      $productDesLinks.find('.product__main-description-size')
      .on('click',()=>{
        $productSizeGuide.find('.product__size-guide-title').click();
      })
    }

    //pdp Shop The Look
    var $shopTheLook = $('.product-shopTheLook-content');
    if($shopTheLook) {
      $(window).resize(() => {
        Shopify.theme.jsProduct.shopTheLookFlicky(1);
      })
      Shopify.theme.jsProduct.shopTheLookFlicky();
    }

    // pdp sticky bar handler
    Shopify.theme.jsProduct.stickyBarHandler();

    // pdp select option if has query in url
    Shopify.theme.jsProduct.selectOptionByURL();


    // gift card validate
    var $productCard = $('.product__gift-card');
    if ($productCard) {
      Shopify.theme.jsProduct.bindGiftCardEvent($productCard);
    }

     // remove on load disable on Single Variant Product
     if($('.swatch-element').length === 0){
       $('[data-add-to-cart-trigger]').removeAttr('disabled');
     }

    $(".product_form_options", $section).each(function () {
      new Shopify.OptionSelectors($(this).data("select-id"), {
        product: $(this).data("product"),
        onVariantSelected: selectCallback,
        enableHistoryState: $(this).data("enable-state")
      });
    });

    if (window.location.search === '?contact_posted=true') {
      $('.notify_form .contact-form').hide();
      $('.notify_form .contact-form').prev('.message').html(Shopify.translation.notify_form_success);
    }

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function () {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if ($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function success(data) {
              $nf.fadeOut("slow", function () {
                $nf.prev('.message').html(Shopify.translation.notify_form_success);
              });
            },
            error: function error(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          // e.preventDefault();
        }
      });
    });

    if (Shopify.theme_settings.product_form_style === "swatches") {
      this.enableProductSwatches();
    } else if (Shopify.theme_settings.product_form_style === "dropdown") {
      $('.selector-wrapper select', $section).wrap('<span class="select" data-dropdown-form-style></span>');
      this.findSelectedVariantImage();
    }

    if ($('.masonry--true').length > 0) {
      Shopify.theme.applyMasonry('.thumbnail');
    }
  },
  enableKlaviyoBIS: function enableKlaviyoBIS(){
    /**
     * The clearForm function enables the email input field and hides the notify-me element.
     */
  
    function successForm() {
      $("#email").attr("disabled", false);
      $('#notify-me').hide();
      $("#completed_message").show();
    }
    function resetForm() {
      $('#notify-me').show();
      $("#completed_message").hide();
    }
    /**
     * The function `subscribeToKlaviyo` sends a POST request to subscribe a user to Klaviyo's
     * back-in-stock notifications.
     */
    function subscribeToKlaviyo() {
      const notifyMeBtn = document.querySelector('#klaviyo-notify-me');
      let klaviyoID = null;
      if (notifyMeBtn) {
        klaviyoID = notifyMeBtn.getAttribute('data-klaviyo-id');
      }
      const email = document.querySelector('#email').value;
      const select = document.querySelector('#klaviyo-notify-me #variants');
      let variantID = null;
      if (select) {
        variantID = select.options[select.selectedIndex].value;
      }

      $("#email").attr("disabled", true);
      
      if (!klaviyoID || !email || !variantID) {
        console.error('Klaviyo ID, email, or variant ID is missing');
        return;
      }

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: `${email.trim()}`,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantID}`,
              },
            },
          },
        },
      };

      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "revision":"2025-01-15"
        },
        body: JSON.stringify(payload),
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoID}`, requestOptions)
      .then((response) => {
        if (response.status === 202) {
          successForm();
        } else {
          throw new Error('Failed to subscribe to Klaviyo');
        }
      })
      .catch(error => console.log('error', error));
    }

    /* klaviyo form for coming soon products */
    const notifyMeBtn = $('klaviyo-bis-container');
    if (notifyMeBtn) {
      $('#klaviyo-form').on('submit', function(e) {
        e.preventDefault();

        if( $("#email").val().length ) {
          subscribeToKlaviyo();
        }
      });
    };

    if($('.single-product-variant').length && $('.purchase-details').length == 0) {
      $('.klaviyo-bis-trigger').show();
    }

    $('.klaviyo-bis-trigger').on('click', function(){
      $('.klaviyo-bis-container').show();
      resetForm();

    });
    $('#klaviyo-notify-me select').on('change', function() {
      resetForm();
    });

    $('.klaviyo-bis-close').on('click', function(event) {
      const str = event.target.className;
      if (str.indexOf("klaviyo-bis-close") >= 0) {
        $('.klaviyo-bis-container').hide();
      }
    });

  },

  enableStickyScroll: function enableStickyScroll($productGallery) {
    var announcementHeight = 0;
    var headerHeight = 0;

    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = $('#announcement-bar').outerHeight();
    }

    if (Shopify.theme_settings.header_layout != 'vertical') {
      if (Shopify.theme.jsHeader.enable_sticky) {
        headerHeight = $('#header').outerHeight();
      }
    }

    $productGallery.stick_in_parent({
      offset_top: announcementHeight + headerHeight + 20
    });
  },

  enableLightbox: function enableLightbox($productGallery) {
    $productGallery.find('.product-gallery__link').fancybox({
      beforeClose: function beforeClose(instance, slide) {
        var $instanceGallery = instance.$trigger.first().parents('.product-gallery__main');
        $instanceGallery.hide();
        setTimeout(function () {
          $instanceGallery.fadeIn(100);
        }, 500);
      },
      afterClose: function afterClose() {
        setTimeout(function () {
          $productGallery.find('.is-selected a').focus();
        }, 500);
      }
    });
  },
  enableZoom: function enableZoom($productGallery) {
    $productGallery.find('img').wrap('<span class="zoom-container"></span>').css('display', 'block').parent().zoom({
      touch: false,
      magnify: 1
    });
  },
  disableSlideshow: function disableSlideshow($section, selector) {
    var $slider;

    if ($section) {
      $slider = $section.find('.flickity-enabled');
    } else {
      $slider = $(selector);
    }

    if ($slider && $slider.length && typeof $slider.flickity === 'function') {
      $slider.flickity('destroy');
    }
  },
  enableSlideshow: function enableSlideshow(selector, settings) {
    // Define variables
    var $productGallery = selector;
    var $thumbnailProductGallery = $productGallery.closest('.product-gallery').find('.product-gallery__thumbnails'); // Adds 'product-gallery__image' class if not present

    $productGallery.find('.gallery-cell:not(.product-gallery__image)').addClass('product-gallery__image'); // Adds 'product-gallery__thumbnail' class if not present

    $thumbnailProductGallery.find('.gallery-cell:not(.product-gallery__thumbnail)').addClass('product-gallery__thumbnail');
    var $slides = $productGallery.find('.product-gallery__image');
    var $thumbnails = $thumbnailProductGallery.find('.product-gallery__thumbnail');
    var thumbnailsEnabled;
    var thumbnailsSliderEnabled;
    var thumbnailsPosition;
    var arrowsEnabled;
    var slideshowSpeed;
    var slideshowTransition;

    if (settings) {
      // If custom settings available, use them otherwise take settings from product templates
      thumbnailsEnabled = settings.thumbnailsEnabled;
      thumbnailsSliderEnabled = settings.thumbnailsSliderEnabled;
      thumbnailsPosition = settings.thumbnailsPosition;
      arrowsEnabled = settings.arrowsEnabled;
      slideshowSpeed = settings.slideshowSpeed;
      slideshowTransition = settings.slideshowTransition;
    } else {
      thumbnailsEnabled = Shopify.theme.jsProduct.thumbnails_enabled;
      thumbnailsSliderEnabled = Shopify.theme.jsProduct.enable_thumbnail_slider;
      thumbnailsPosition = Shopify.theme.jsProduct.thumbnail_position;
      arrowsEnabled = Shopify.theme.jsProduct.thumbnail_arrows;
      slideshowSpeed = Shopify.theme.jsProduct.slideshow_speed;
      slideshowTransition = Shopify.theme.jsProduct.slideshow_transition;
    }

    $productGallery.on('ready.flickity', function () {
      $slides.each(function (index, slide) {
        //Determine media type
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');
        var videoID;
        var videoLooping = $('[data-video-loop]').data('video-loop');

        switch (mediaType) {
          case 'external_video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (var i = 0; i < videoPlayers.length; i++) {
                if (videoPlayers[i].id == videoID || videoPlayers[i].media.id == videoID) {
                  videoPlayers[i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[i].keyboard = {
                      focused: false,
                      global: false
                    };
                  }
                }
              }
            }

            break;

          case 'video':
            videoID = $(slide).find('[data-plyr-video-id]').data('plyr-video-id');

            if (videoPlayers) {
              for (var _i = 0; _i < videoPlayers.length; _i++) {
                if (videoPlayers[_i].id == videoID || videoPlayers[_i].media.id == videoID) {
                  videoPlayers[_i].loop = videoLooping;

                  if (!$(slide).hasClass('is-selected')) {
                    videoPlayers[_i].keyboard = {
                      focused: true,
                      global: false
                    };
                  }
                }
              }
            }

            break;

          case 'model':
            if ($(slide).hasClass('is-selected')) {
              //When active slide
              if (mediaType == 'model' && isScreenSizeLarge()) {
                $(slide).on('mouseenter', function () {
                  if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                    $productGallery.flickity('unbindDrag');
                  }
                });
                $(slide).on('mouseleave', function () {
                  if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                    $productGallery.flickity('bindDrag');
                  }
                });
              }
            }

        } // Detect keyboard 'ENTER' key on slides


        $(slide).keypress(function (event) {
          if (event.which == 13) {
            // Bring focus to media inside selected slide
            $(slide).find('model-viewer, .product-gallery__link, .plyr').focus(); // Run video autoplay logic if featured media is a video

            if (mediaType == 'video' || mediaType == 'external_video') {
              checkForVideos();
            } // Autoplay model if featured media is a model


            if (mediaType == 'model') {
              // If model container has class is-selected then play the model
              autoplayModel();
            }
          }
        });
      });
    });
    $productGallery.flickity({
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: $productGallery.data('media-count') > 1 || $slides.length > 1 ? true : false,
      autoPlay: slideshowSpeed * 1000,
      fade: slideshowTransition === 'fade' ? true : false,
      watchCSS: this.template === 'image-scroll' ? true : false,
      arrowShape: arrowShape
    });
    $productGallery.on('change.flickity', function () {
      $slides.each(function (index, slide) {
        //Determine media type of current slide
        var mediaType = $(slide).data('media-type') || $(slide).find('[data-media-type]').data('media-type');

        if ($(slide).hasClass('is-selected')) {
          //When active slide
          switch (mediaType) {
            case 'model':
              /* On slide change, if active slide contains 3d model
              * If on desktop, on hover, unbind flickity, after hover bind flickity
              * On model play event, unbind flickity to ensure model can be interacted with
              * On model pause event, bind flickity so that slide can be swiped
              * Pause all model slides when hidden
              */
              if (isScreenSizeLarge()) {
                // On mouseenter event, unbind flickity
                $(slide).on('mouseenter', function () {
                  if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                    $productGallery.flickity('unbindDrag');
                  }
                }); // On mouseleave event, bind flickity

                $(slide).on('mouseleave', function () {
                  if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                    $productGallery.flickity('bindDrag');
                  }
                });
              } // Listen for model pause/play events


              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_play', function () {
                if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                  $productGallery.flickity('unbindDrag');
                }
              });
              $(slide).find('model-viewer').on('shopify_model_viewer_ui_toggle_pause', function () {
                if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                  $productGallery.flickity('bindDrag');
                }
              });
              break;

            default:
              if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
                $productGallery.flickity('bindDrag');
              }
          }
        } else {
          //When inactive slide
          switch (mediaType) {
            case 'external_video':
              //Youtube video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'video':
              //HTML5 video pausing
              $.each(videoPlayers, function (index, player) {
                player.pause();
              });
              break;

            case 'model':
              $.each(Shopify.theme.productMedia.models, function (index, model) {
                model.pause();
              });
          }
        }
      }); //Restore 3d model icons

      Shopify.theme.productMedia.showModelIcon($productGallery);
    }); // Checks for videos and plays them if they are the featured media
    // Autoplay logic only happens on desktop, autoplay set to off for mobile

    var $sliderArrows = $productGallery.find('.flickity-prev-next-button');

    if (($sliderArrows || $thumbnails) && isScreenSizeLarge()) {
      $sliderArrows.on('click', function () {
        $productGallery.on('settle.flickity', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.on('click', function (event) {
        var index = $(event.currentTarget).index();
        if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
          $productGallery.flickity('select', index);
        }
        $productGallery.on('settle.flickity', function (event, index) {
          // Find out media type of featured media slide
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var mediaType = $selectedSlide.data('media-type') || $selectedSlide.find('[data-media-type]').data('media-type');
          var pId = $productGallery.data('product-id'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          $productGallery.off('settle.flickity');
        });
        return false;
      });
      $thumbnails.keypress(function (event) {
        var index = $(event.currentTarget).index();

        if (event.which == 13) {
          if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
            $productGallery.flickity('select', index);
          }
          var $selectedSlide = $productGallery.find('.product-gallery__image.is-selected');
          var pId = $productGallery.data('product-id');
          $productGallery.on('settle.flickity', function (event, index) {
            $selectedSlide.find('model-viewer, .plyr, a').focus();
            $selectedSlide.find('[data-youtube-video]').attr('tabindex', '0');
            $productGallery.off('settle.flickity');
          }); // Find out media type of featured media slide

          var mediaType = $selectedSlide.data('media-type') || $selected.find('[data-media-type]').data('media-type'); // Run video autoplay logic if featured media is a video

          if (mediaType == 'video' || mediaType == 'external_video') {
            checkForVideos();
          } // Autoplay model if featured media is a model


          if (mediaType == 'model') {
            // Sort models to get those in selected slide
            var sortedModels = [];
            $.each(Shopify.theme.productMedia.models, function (index, model) {
              if ($(model.container).closest('.product-gallery__image').data('product-id') == pId) {
                sortedModels.push(model);
              }
            }); // If model container has class is-selected then play the model

            $.each(sortedModels, function (index, model) {
              var $slide = $(model.container).parents('.product-gallery__image');

              if ($slide.hasClass('is-selected')) {
                model.play();
              }
            });
          }

          return false;
        }
      });
    }

    function checkForVideos() {
      $slides.each(function (index, slide) {
        // Variables
        var $slide = $(slide);
        var mediaType = $slide.data('media-type') || $slide.find('[data-media-type]').data('media-type');
        var videoID = $slide.find('video').data('plyr-video-id');
        var $iframeVideo = $slide.find('iframe');
        var iframeID = $iframeVideo.attr('id');

        if ($slide.hasClass('is-selected')) {
          if (mediaType == 'video') {
            videoID = $slide.find('video').data('plyr-video-id');

            if (videoID) {
              autoplayVideo(videoID, $slide);
            }
          } else if (mediaType == 'external_video' && iframeID) {
            autoplayYoutubeVideo(iframeID, $slide);
          }
        }
      });
    }

    function autoplayVideo(videoID, $slide) {
      // Compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    function autoplayYoutubeVideo(iframeID, $slide) {
      // compare id to player object and only play that video
      $.each(videoPlayers, function (index, player) {
        if (player.playing) {
          player.pause();
        }

        if (player.media.id == iframeID) {
          player.play(); // On fullscreen toggle, focus back on the slide itself

          player.on('exitfullscreen', function () {
            $slide.closest('.product-gallery').find('.product-gallery__thumbnails').focus();
          });
        }
      });
    }

    setTimeout(function () {
      if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
        $productGallery.flickity('resize');
      }
    }, 500);
    $(window).on('load', function () {
      if ($productGallery && $productGallery.length && typeof $productGallery.flickity === 'function') {
        $productGallery.flickity('resize');
      }
    });

    if (thumbnailsEnabled == true && thumbnailsSliderEnabled == true && $slides.length > 1) {
      //If desktop determine which slider we build
      if (isScreenSizeLarge()) {
        if (thumbnailsPosition == 'right-thumbnails' || thumbnailsPosition == 'left-thumbnails') {
          $thumbnailProductGallery.addClass('vertical-slider-enabled');
          var navCellHeight = $thumbnails.height();
          var navHeight = $thumbnailProductGallery.height();
          $productGallery.on('select.flickity', function () {
            // set selected nav cell
            var flkty = $productGallery.data('flickity');

            if (flkty) {
              $thumbnailProductGallery.find('.is-nav-selected').removeClass('is-nav-selected');

              var _$selected = $thumbnails.eq(flkty.selectedIndex).addClass('is-nav-selected'); // scroll nav


              var scrollY = _$selected.position().top + $thumbnailProductGallery.scrollTop() - (navHeight + navCellHeight) / 2;
              $thumbnailProductGallery.animate({
                scrollTop: scrollY
              });
            }
          });
        } else {
          $thumbnailProductGallery.flickity({
            cellAlign: 'center',
            contain: true,
            groupCells: '80%',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
            asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
            arrowShape: arrowShape
          }); // Ensures Flickity is not collapsed when loaded

          setTimeout(function () {
            $thumbnailProductGallery.flickity('resize');
          }, 500);
          $(window).on('load', function () {
            $thumbnailProductGallery.flickity('resize');
          });
        }
      } else {
        //Otherwise create standard thumbnail slider
        $thumbnailProductGallery.flickity({
          cellAlign: 'center',
          contain: true,
          groupCells: '80%',
          imagesLoaded: true,
          pageDots: false,
          prevNextButtons: $thumbnails.length > 5 ? arrowsEnabled : false,
          asNavFor: this.template === 'image-scroll' && isScreenSizeLarge() ? '' : $productGallery[0],
          arrowShape: arrowShape
        });
      }
    }
  },
  enableProductSwatches: function enableProductSwatches() {
    $('body').on('change', '.swatch :radio', function () {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      var parentForm = $(this).closest('.product_form form');

      if (parentForm.siblings('.notify_form').length) {
        var notifyForm = parentForm.siblings('.notify_form');
      } else {
        var notifyForm = $('.js-notify-form');
      }

      var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
      var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
      var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

      if (option1 && option2 && option3) {
        var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
      } else if (option1 && option2) {
        var notifyMessage = option1 + ' / ' + option2;
      } else {
        var notifyMessage = option1;
      }

      notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage);
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    }); //Swatches linked with selected options

    if ($('.js-product_section').length) {
      var $productForms = $('.js-product_section').find('.product_form');
      $productForms.addClass('is-visible'); //Loop through each product and set the initial option value state

      $productForms.each(function () {
        var JSONData = $(this).data('product');
        var productID = $(this).data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).find('.swatch_options .swatch');

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    } //Add click event when there is more than one product on the page (eg. Collection in Detail)


    if ($('.js-product_section').length > 1) {
      $('body').on('click', '.swatch-element', function (e) {
        var swatchValue = $(this).data('value').toString();
        $(this).siblings('input[value="' + swatchValue.replace(/\"/g, '\\"') + '"]').prop("checked", true).trigger("change");
        var JSONData = $(this).parents('.product_form').data('product');
        var productID = $(this).parents('.product_form').data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');

        const $currentTarget = $(e.currentTarget);
        $currentTarget.parent().prev().find('.option-title-value').html(swatchValue)

        if (swatchOptions.length > 1) {
          Shopify.linkOptionSelectors(JSONData, productSection);
        }
      });
    }

    this.findSelectedVariantImage();
  },
  findSelectedVariantImage: function findSelectedVariantImage() {
    $('[data-variant-selector]').on('selectedVariantChanged', function () {
      if ($(this).attr('disabled')) {
        return;
      } else {
        getIndex($(this), $(this).val());
      }
    });

    function getIndex($selector, variantID) {
      var $parentForm = $selector.parents('.product_form');
      var $option = $parentForm.find("select option[value=".concat(variantID, "]"));
      var imageID = $option.attr('data-image-id');

      if (!imageID) {
        // If there is no image, no scrolling occurs
        return false;
      }

      var index = $("[data-image-id=".concat(imageID, "]")).data('index');

      if (Shopify.theme.jsProduct.template === 'image-scroll') {
        Shopify.theme.jsProduct.scrollSelectedImage(index);
      }
    }
  },
  scrollSelectedImage: function scrollSelectedImage(variant) {
    var headerHeight = 0;
    var announceHeight = 0; // Get header height is sticky enabled

    if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
    } // Get announcement height is sticky enabled


    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
      announceHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    } // Add values


    var totalHeight = headerHeight + announceHeight;
    Shopify.theme.scrollToTop($("[data-index=\"".concat(variant, "\"]")), totalHeight);
  },
  relatedProducts: function relatedProducts() {
    $('.block__recommended-products .js-related-products-slider .products-slider').each(function (index, value) {
      var $relatedSlider = $(this);
      var slideData = {
        products_per_slide: $relatedSlider.data('products-per-slide'),
        products_available: $relatedSlider.data('products-available'),
        products_limit: $relatedSlider.data('products-limit'),
        initialIndex: 0,
        cellAlign: "left",
        prevNextButtons: true,
        wrapAround: true
      };

      if (slideData.products_available > slideData.products_per_slide && slideData.products_limit > slideData.products_per_slide) {
        slideData.wrapAround = true;
      } else {
        slideData.wrapAround = false;
      }

      if (slideData.products_limit > slideData.products_per_slide &&  slideData.products_available > slideData.products_per_slide) {
        slideData.prevNextButtons = true;
      }
      else {
        slideData.prevNextButtons = false;
      }

      if (slideData.products_available < slideData.products_per_slide || slideData.products_limit < slideData.products_per_slide) {
        $relatedSlider.addClass('container is-justify-center');
        $relatedSlider.find('.gallery-cell').addClass('column');
      } else {
        $relatedSlider.flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          wrapAround: true,
          // wrapAround: slideData.wrapAround,
          pageDots: slideData.prevNextButtons,
          contain: true,
          prevNextButtons: slideData.prevNextButtons,
          // initialIndex: 0,
          initialIndex: slideData.initialIndex,
          arrowShape: arrowShape
        });
        setTimeout(function () {
          $relatedSlider.flickity('resize');
        }, 500);
        $(window).on('load', function () {
          $relatedSlider.flickity('resize');
        });
      }
    });
  },
  // pdp guide handler
  featuresEventHandler: function featuresEventHandler() {
    var $productFeaturesSec = $('.product-features-section');
    var activeEleIndex = 0;
      $productFeaturesSec.on('click', (e)=> {
        var slideInterval = 300;
        var $currentTarget = $(e.currentTarget);
        var currentIndex = Number($currentTarget.attr('data-index'));
        var $guideContent = $currentTarget.find('.product-features-content');
        var $guideTitle = $currentTarget.find('.product-features-title');
        var $iconHide = $currentTarget.find('.product-features-hide');
        var $iconShow = $currentTarget.find('.product-features-show');

        console.log('currentIndex',currentIndex)
        console.log('activeEleIndex',activeEleIndex)
        if( currentIndex !== activeEleIndex &&  $(`.product-features-section[data-index=${activeEleIndex}]`).hasClass('active')) {
          const $prev = $(`.product-features-section[data-index=${activeEleIndex}]`);

          activeEleIndex = currentIndex;


          const $guideContent = $prev.find('.product-features-content');
          const $iconHide = $prev.find('.product-features-hide');
          const $iconShow = $prev.find('.product-features-show');

          $iconHide.toggleClass('active');
          $iconShow.toggleClass('active');
          $guideContent.slideToggle(slideInterval);
          $prev.toggleClass('active')
        }
        else {
          activeEleIndex = currentIndex;
        }
        console.log('continue')

        $iconHide.toggleClass('active');
        $iconShow.toggleClass('active');
        $guideContent.slideToggle(slideInterval);
        $currentTarget.toggleClass('active');

    })
  },
  // pdp size guide handler
  sizeGuideHandler: function sizeGuideHandler($sizGuide,$title) {
    // open the size guide as default
    var $popUpModel = $('.product__size-guide-popup');
    $title.on('click',()=>{
      $popUpModel.removeClass('invisible')
    });

    const $subTitle = $('.product__size-guide-popup').find('.popup-title span');
    const $sizeGuideTitle = $('.product__size-guide-popup').find('.popup-subtitle-size span');
    const $fitGuideTitle = $('.product__size-guide-popup').find('.popup-subtitle-fit span');
    const $sizeGuideTag = $('.product__size-guide-popup').find('.popup-sizeguide');
    const $fitGuideTag = $('.product__size-guide-popup').find('.popup-fitguide');

    $sizeGuideTitle.on('click', ()=> {
      if($sizeGuideTitle.hasClass('active')) {
        return
      }
      else{
        $sizeGuideTitle.addClass('active');
        $sizeGuideTag.addClass('active');
        $fitGuideTitle.removeClass('active');
        $fitGuideTag.removeClass('active');
        $subTitle.html('size guide');
      }
    })

    $fitGuideTitle.on('click', ()=> {
      if($fitGuideTitle.hasClass('active')) {
        return
      }
      else{
        $sizeGuideTitle.removeClass('active');
        $sizeGuideTag.removeClass('active');
        $fitGuideTitle.addClass('active');
        $fitGuideTag.addClass('active');
        $subTitle.html('fit guide');

        const collectionId = $fitGuideTag.attr('data-id');
      }
    })

    // close the pop up
    var $popUpClose = $('.popup-close');
    $popUpClose.on('click',()=>{
      $popUpModel.animate({right:'-999px'},500);
      setTimeout(()=>{
        $popUpModel.addClass('invisible').css({'right':'0'});
        // $sizeGuideTitle.addClass('active');
        // $sizeGuideTag.addClass('active');
        // $fitGuideTitle.removeClass('active');
        // $fitGuideTag.removeClass('active');
        // $subTitle.html('size guide');
      },600)
    })
  },
  stickyBarHandler: function stickyBarHandler() {
    const $sitckyBar = $('.product__sticky');
    const $pdpInfo = $('.product__information');
    const $pdpSwatches = $('.swatch_options').find('.swatch');
    const $stickySwatch = $sitckyBar.find('.product__sticky-swatch');
    const $originalPrice = $sitckyBar.find('.product__sticky-price-original');
    const $currentPrice =  $sitckyBar.find('.product__sticky-price-current');

    // sticky bar displaying
    const $pdpAnchor = $(".product__scroll-anchor");
    const pdpScrollTop = $pdpAnchor.offset().top;

    $(window).scroll(()=>{
        var fromTop = $(document).scrollTop();
        if (fromTop > pdpScrollTop - 10) {
          $sitckyBar.removeClass('invisible');
        }
        else {
          $sitckyBar.addClass('invisible');
        }
    })

    // layout displaying
    $stickySwatch.on('click',(e)=>{
      const $currentTarget = $(e.currentTarget);
      const name = $currentTarget.attr('name');

      $stickySwatch.map((i)=>{
        const name_i = $($stickySwatch[i]).attr('name');
        if (name !== name_i) {
          $($stickySwatch[i]).find('.product__sticky-swatch-values').addClass('invisible');
        }
      })

      $currentTarget.find('.product__sticky-swatch-values').toggleClass('invisible');
    })

    setTimeout(()=>{
      // sticky bar price init
      Shopify.theme.jsProduct.initStickyBarPrice();

      // sticky bar swatch init
      $pdpSwatches.map((i)=>{
        const $swatch = $($pdpSwatches[i]);
        const swatchName = $swatch.attr('name');
        const defaultValue = $swatch.find('.swatch-container').find('input:checked').attr('value');
        $swatch.find('.option-title-value').html(defaultValue)
        $sitckyBar.find(`.product__sticky-swatch[name=${swatchName}]`).find('.product__sticky-swatch-default').html(defaultValue); // init default value

        const $soldOutEle =  $swatch.find('.swatch-container').find('.soldout');
        $soldOutEle.map((j)=>{
          const value = $($soldOutEle[j]).attr('data-value');
          $sitckyBar.find(`.product__sticky-swatch[name=${swatchName}]`).find('.product__sticky-swatch-values').find(`span[value=${value}]`).addClass('soldout');
          if(defaultValue == value) {
            $sitckyBar.find(`.product__sticky-swatch[name=${swatchName}]`).find('.product__sticky-swatch-default').addClass('soldout');
          }
        })
      })
    },0)

    // swatch click
    const $swatchEle = $pdpInfo.find('.swatch-element');
    $swatchEle.on('click',(e)=>{
      const $currentEle = $(e.currentTarget);
      const value = $currentEle.attr('data-value');
      const name =  $currentEle.attr('name');
      const $related = $sitckyBar.find(`.product__sticky-swatch[name=${name}]`).find('.product__sticky-swatch-default');
      if($currentEle.hasClass('soldout')) {
        $related.addClass('soldout');
      }
      else {
        $related.removeClass('soldout');
      }
      $related.html(value);
      setTimeout(()=>{
        Shopify.theme.jsProduct.initStickyBarPrice();
      },200)

      $pdpSwatches.map((i)=>{
        const $swatch = $($pdpSwatches[i]);
        const swatchName = $swatch.attr('name');
        if(swatchName !== name) {
          const $stickyDropDownItems = $sitckyBar.find(`.product__sticky-swatch[name=${swatchName}]`);
          const $ele = $swatch.find('.swatch-container').find('.swatch-element');
          setTimeout(()=>{
            $ele.map((j)=>{
              const dataValue = $($ele[j]).attr('data-value');
              if($($ele[j]).hasClass('soldout')){
                $stickyDropDownItems.find(`.product__sticky-swatch-value[value=${dataValue}]`).addClass('soldout');
              }
              else {
                $stickyDropDownItems.find(`.product__sticky-swatch-value[value=${dataValue}]`).removeClass('soldout');
              }
            })
          },200)
        }
      })
    })

    // sticky bar click
    $sitckyBar.find('.product__sticky-swatch-value').on('click',(e)=>{
      const $currentTarget = $(e.currentTarget);
      const value = $currentTarget.html();
      e.stopPropagation();
      $currentTarget.parent().addClass('invisible').prev().html(value);

      $pdpInfo.find(`.swatch-element[data-value=${value}]`).click();

      setTimeout(()=>{
        $currentPrice.html($pdpInfo.find('.current_price .money').html());
        if( $pdpInfo.find('.was-price .money').html()) {
          $originalPrice.html($pdpInfo.find('.was-price .money').html());
        }
      },200)
    })

    // add to bag
    $sitckyBar.find('.product__sticky-add').on('click',()=>{
      $pdpInfo.find('.button--add-to-cart').click();
      // $('html,body').animate({ scrollTop: 0 }, 800);
    })

  },
  getRequest: function getRequest() {
    const url = location.search;
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
      let str = url.substr(1);
      const strs = str.split("&");
      for(let i = 0; i < strs.length; i ++) {
        theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
      }
    }
    return theRequest;
 },
  selectOptionByURL: function selectOptionByURL() {
    const query =  Shopify.theme.jsProduct.getRequest();
    try {
      setTimeout(()=>{
        const size = query.size;
        const $ele = $(`.swatch-element[data-value=${size}]`);
        $ele.click();

      },100)
    }
    catch {

    }
  },
  bindGiftCardEvent: function bindGiftCardEvent ($productCard) {
    const $email = $productCard.find('#recipient-email');

    const reg  = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
    $email.on('blur',(e)=>{
      const value = $(e.currentTarget).val();
      if(reg.test(value)) {
        $productCard.find('.line-item-property__field-email').find('span').addClass('invisible')
      }
      else {
        $productCard.find('.line-item-property__field-email').find('span').removeClass('invisible')
      }
    })

    // const $name = $productCard.find('#recipient-name');
    // $name.on('blur',(e)=>{
    //   const value = $(e.currentTarget).val();
    //   if(!value) {
    //     $productCard.find('.line-item-property__field-name').find('span').removeClass('invisible')
    //   }
    // })
  },
  shopTheLookFlicky: function shopTheLookFlicky(isResize) {
    const $shopTheLook = $('.product-shopTheLook-content');
    let settings = {
          lazyLoad: 2,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'left',
          contain: true,
          freeScroll: true,
          wrapAround: true,
          pageDots: true,
          prevNextButtons: true,
          initialIndex: 0
      }

    if ($shopTheLook.find('.product-shopTheLook-item').length > 4) {
      $shopTheLook.removeClass('flexible')
      $shopTheLook.flickity(settings)
    } else if (($(window).width() < 1009) && $shopTheLook.find('.product-shopTheLook-item').length > 2) {
      settings.lazyLoad = 2;
      settings.prevNextButtons=false;
      $shopTheLook.flickity(settings)
    }
    else {
      $shopTheLook.flickity('destroy')
      $shopTheLook.addClass('flexible')
    }
  },
  initStickyBarPrice: function initStickyBarPrice() {
    const $sitckyBar = $('.product__sticky');
    const $pdpInfo = $('.product__information');
    const $originalPrice = $sitckyBar.find('.product__sticky-price-original');
    const $currentPrice =  $sitckyBar.find('.product__sticky-price-current');
    const current = $pdpInfo.find('.current_price .money').html();
    const old = $pdpInfo.find('.was-price .money').html();

    if(old) {
      $originalPrice.html(old);
    }
    else if(current){
      $currentPrice.html(current);
    }
    else {
      $currentPrice.html('Sould Out');
    }
  },
  unload: function unload($section) {
    $('.selector-wrapper select', $section).unwrap();
    this.disableSlideshow($section);
    $('[data-variant-selector]').off();
  }
};
